import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface ApplyWithoutProfileResponse extends BackendResponse {
  idCandidate: number | null;
  idVacancyCandidate: number | null;
  idRecruitmentCandidate: number | null;
  foundExistingCandidate: boolean;
  foundExistingCaseCandidate: boolean;
}
export interface ApplyWithoutProfileParameters extends NextApiParams {
  /**
   * attachment: any | null;
   * firstName: string;
   * lastName: string;
   * mobile: string;
   * email: string;
   * acceptedGeneralConsent: boolean;
   * idLanguage: number | null;
   * typeRelation: number;
   * idRelation: number;
   * applicationText: string;
   */
  formData: FormData;
}

export const applyWithoutProfile = withNextApi<
  ApplyWithoutProfileResponse,
  ApplyWithoutProfileParameters
>("/cvp/CvpApplyWithoutProfile");
